import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TreeSelectModule } from 'primeng/treeselect';

import { TranslateModule } from '@ngx-translate/core';

// DevExtreme modules
import {
  DxButtonModule,
  DxSelectBoxModule,
  DxTextAreaModule,
  DxTagBoxModule,
  DxDateBoxModule,
  DxValidatorModule,
  DxDateRangeBoxModule,
  DxNumberBoxModule,
  DxTextBoxModule,
  DxResponsiveBoxModule,
  DxFormModule,
  DxDataGridModule,
  DxBoxModule,
  DxCheckBoxModule,
  DxHtmlEditorModule,
  DxFileUploaderModule,
  DxTemplateModule,
  DxDropDownBoxModule,
  DxTreeViewModule,
  DxLoadPanelModule,
} from 'devextreme-angular';



import { AddButtonComponent } from '../../components/add-button/add-button.component';
import { SharedModalComponent } from '../../components/shared-modal/shared-modal.component';
import { DataNotFoundComponent } from '../../components/data-not-found/data-not-found.component';
import { GenerateReportComponent } from '../../components/generate-report/generate-report.component';
import { PositiveNumberDirective } from './positive-number.directive';


// Custom shared components

@NgModule({
  declarations: [PositiveNumberDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TranslateModule,

    // DevExtreme
    DxButtonModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxDateRangeBoxModule,
    DxNumberBoxModule,
    DxTextBoxModule,
    DxResponsiveBoxModule,
    DxFormModule,
    DxDataGridModule,
    DxBoxModule,
    DxCheckBoxModule,
    DxFileUploaderModule,
    DxHtmlEditorModule,
    DxTemplateModule,
    AddButtonComponent,
    GenerateReportComponent,
    SharedModalComponent,
    DataNotFoundComponent,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxLoadPanelModule,

    TreeSelectModule,
  ],
  exports: [
    // Angular modules
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    TranslateModule,

    // DevExtreme modules
    DxButtonModule,
    DxSelectBoxModule,
    DxTextAreaModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxDateRangeBoxModule,
    DxNumberBoxModule,
    DxTextBoxModule,
    DxResponsiveBoxModule,
    DxFormModule,
    DxDataGridModule,
    DxBoxModule,
    DxCheckBoxModule,
    DxFileUploaderModule,
    DxHtmlEditorModule,
    DxTemplateModule,
    AddButtonComponent,
    SharedModalComponent,
    DataNotFoundComponent,
    TreeSelectModule,
    DxDropDownBoxModule,
    GenerateReportComponent,
    DxTreeViewModule,
    // Shared components
    PositiveNumberDirective,
  ]
})
export class DevextremesharedmoduleModule { }
